module.exports = __webpack_public_path__ + "static/img/KM.036d8831.png";